(() => {
  // app/scripts/filter-component.js
  var showMoreCount = 7;
  var { debounceTime, addEvent } = theme;
  customElements.define("filter-component", class extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
      this.cache = [];
      this.andLogic = JSON.parse(this.dataset.andLogic || "false");
      this.filterType = this.dataset.type || "attribute";
      this.form = this.querySelector("form");
      this.inputClass = `input[form="${this.form.id}"]`;
      this.viewStyle = this.querySelector("view-style");
      this.popupSelectStore = document.querySelector("popup-select-store");
      this.customChangeStore = this.querySelector("custom-change-store");
      if (this.customChangeStore) {
        this.jsMyStore = this.customChangeStore.querySelector(".jsMyStore");
        this.btnChange = this.customChangeStore.querySelector(".btn-change");
        this.btnSelect = this.customChangeStore.querySelector(".btn-select");
      }
      let storage = sessionStorage.getItem("collection_cookie");
      let infinite_loading = document.querySelector("infinite-loading");
      if (storage != null && infinite_loading == null) {
        this.check = true;
        storage = JSON.parse(storage);
        document.querySelectorAll(".list-products  product-card").forEach((e) => {
          if (e.dataset.productId == storage.id) {
            e.classList.add("active");
            this.scroll(e);
            sessionStorage.removeItem("collection_cookie");
            this.check = false;
          }
        });
      }
    }
    connectedCallback() {
      this.addEvents();
      this.checkFilterActive();
      if (this.jsMyStore) {
        this.pickUp();
      }
      this.addEventListener("change:store", (evt) => {
        this.pickUp();
        this.submit();
      });
    }
    scroll(scrollToEl) {
      const topOfElement = window.scrollY + scrollToEl.getBoundingClientRect().top - document.querySelector(".header-section").offsetHeight;
      window.scroll({ top: topOfElement, behavior: "smooth" });
    }
    pickUp() {
      const store = this.popupSelectStore.getStore();
      if (store) {
        let storeName = store.storeName.trim();
        if (storeName.includes("(Head Office)")) {
          storeName = storeName.replace("(Head Office)", "").trim();
        }
        this.jsMyStore.innerHTML = storeName;
        this.btnChange.classList.toggle("none", false);
        this.btnSelect.classList.toggle("none", true);
      } else {
        this.jsMyStore.innerHTML = "";
        this.btnSelect.classList.toggle("none", false);
        this.btnChange.classList.toggle("none", true);
      }
    }
    appendStore(query) {
      let stringQuery = query;
      let temp = "filter.v.availability=1&" + this.jsMyStore.dataset.filterName + this.jsMyStore.textContent.trim();
      stringQuery = stringQuery.replace("filter.v.availability=1", temp);
      return stringQuery;
    }
    checkFilterActive() {
      this.filterActive = this.querySelectorAll(".sidebar-section .filter-active-list li");
      this.btnFilter = this.querySelector(".filter-btn");
      if (this.filterActive?.length) {
        this.btnFilter.classList.add("has-filter");
      }
    }
    addEvents() {
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      this.addEventListener("change", ({ target: selectedTarget }) => {
        if (selectedTarget.name == "sortBy") {
          const sortEl = [...this.querySelectorAll("[name=sort_by]")].find((item) => item.value == selectedTarget.value);
          sortEl.checked = true;
          selectedTarget = sortEl;
        }
        this.onChange(selectedTarget);
      });
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submit();
      });
      this.viewStyle.querySelectorAll("div")?.forEach((item) => item.addEventListener("click", (e) => {
        this.viewStyle.classList = "";
        this.viewStyle.classList.add(item.classList[0]);
        this.classList.remove(item.dataset.classRemove);
        this.classList.add(item.classList[0]);
      }));
      this.removeFilter();
      this.filterSearch();
      this.addEventListener("click", (evt) => {
        const { target } = evt;
        if (target.closest(".jsFilterReset")) {
          evt.preventDefault();
          this.uncheckInput();
          this.submit();
        }
      });
    }
    onChange(target) {
      const input = target;
      !this.andLogic && this.uncheckInput(input);
      if (target.hasAttribute("auto-submit"))
        this.submit();
    }
    uncheckInput(input = null) {
      let inputList;
      if (input) {
        inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
      } else {
        inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
      }
      inputList.forEach((i) => {
        i.removeAttribute("checked");
        i.checked = false;
      });
    }
    get getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (this.filterType == "attribute")
        return query.toString();
      const arrayFilter = [];
      let sort = "";
      query.split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    submit() {
      let query = this.getQueryString;
      if (query.includes("filter.v.availability=1") && this.jsMyStore) {
        query = this.appendStore(query);
      }
      const findInCache = this.cache.find((i) => i.query == query);
      if (findInCache) {
        this.render(findInCache.DOM, findInCache.query);
        return;
      }
      let url = this.form.action;
      url += this.filterType == "attribute" ? url.includes("?") ? "&" : "?" : "/";
      url += query;
      url += this.filterType == "attribute" || query.includes("?") ? "&" : "?";
      url += `section_id=${this.dataset.sectionId}`;
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.cache.push({
          query,
          DOM: div
        });
        this.render(div, query);
        this.checkFilterActive();
      });
    }
    render(result, searchParams = null) {
      if (searchParams) {
        let splitCharacter;
        if (this.filterType == "attribute") {
          splitCharacter = this.form.action.includes("?") ? "&" : "?";
        } else {
          splitCharacter = !searchParams.includes("?") || searchParams.includes("?") && searchParams.split("?")[0].length ? "/" : "";
        }
        history.pushState({ searchParams }, "", `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`);
      }
      this.querySelectorAll(this.inputClass).forEach((input, i) => {
        if (!input.id)
          return;
        input.checked = result.querySelector(`#${input.id}`)?.checked || false;
      });
      this.querySelector("#" + this.dataset.product).innerHTML = result.querySelector("#" + this.dataset.product).innerHTML;
      this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
        const newItem = result.querySelector(`[class="${item.className}"]`);
        if (!newItem)
          return;
        item.innerHTML = newItem.innerHTML;
      });
      this.removeFilter();
    }
    removeFilter() {
      this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const { value } = item.querySelector(".jsValue").dataset;
          this.querySelectorAll(`input[form="${this.form.id}"]`).forEach((item2) => {
            if (item2.value != value)
              return;
            item2.checked = false;
          });
          this.submit();
        });
      });
    }
    filterSearch() {
      this.querySelectorAll(".jsFilterSearch")?.forEach((item) => {
        const parentEl = item.closest(".filter-block");
        item.addEventListener("click", () => {
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
        item.previousElementSibling.addEventListener("keyup", (e) => {
          (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
      });
      const clearField = (el) => {
        el.querySelectorAll("li.matched")?.forEach((item) => item.classList.remove("matched"));
      };
      const searchFilterValue = (container, value) => {
        const filterListItem = container.querySelectorAll("[name*=filter]");
        if (value.length) {
          container.classList.add("searching");
          filterListItem.forEach((item) => {
            let regex = new RegExp(value, "i");
            const parentEl = item.closest("li");
            parentEl.classList.toggle("matched", item.value.match(regex));
          });
        } else {
          container.classList.remove("searching");
          container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
        }
        container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
      };
    }
    sortBrandFilter() {
      const list = this.querySelector(".jsFilterBrands");
      if (!list)
        return;
      let arr = [...list.children];
      arr = arr.sort((a, b) => {
        const prefixA = a.dataset?.prefix.split("_");
        const prefixB = b.dataset?.prefix.split("_");
        const firstComparison = prefixA[0].localeCompare(prefixB[0]);
        if (firstComparison !== 0) {
          return firstComparison;
        }
        return prefixA[0] == prefixB[0] && prefixA[1].localeCompare(prefixB[1]);
      });
      arr.forEach((item, index) => {
        item.classList.toggle("none", index >= showMoreCount);
      });
      list.replaceChildren(...arr);
    }
  });
  addEvent("click", ".jsFilterShowMore", ({ target }) => {
    const container = target.closest(".filter-block");
    if (target.getAttribute("data-more") == "true") {
      const filterList = container.querySelectorAll(".jsFilterToggle.none");
      filterList.forEach((item, value) => {
        value < showMoreCount && item.classList.remove("none");
      });
      const hiddenFilterCount = container.querySelectorAll(".jsFilterToggle.none").length;
      target.setAttribute("data-more", !!hiddenFilterCount);
    } else {
      const totalFilterItems = container.querySelectorAll(".jsFilterToggle");
      const filterList = container.querySelectorAll(".jsFilterToggle:not(.none)");
      [...filterList].forEach((item, value) => {
        value >= showMoreCount && item.classList.add("none");
      });
      target.setAttribute("data-more", "true");
    }
  });
})();
